import { render, staticRenderFns } from "./WithdrawConfirm.vue?vue&type=template&id=73b5411c"
import script from "./WithdrawConfirm.vue?vue&type=script&lang=ts"
export * from "./WithdrawConfirm.vue?vue&type=script&lang=ts"
import style0 from "./WithdrawConfirm.vue?vue&type=style&index=0&id=73b5411c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports